import React from 'react';
import { RefreshCcw, Download } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const PageHeader = ({
  title,
  subtitle,
  children,
  onRefresh,
  onExport,
  className = ''
}) => {
  return (
    <div className={`flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between mb-6 ${className}`} data-testid="page-header">
      <div>
        <h1
          className="text-2xl md:text-3xl font-semibold tracking-tight text-foreground"
          style={{ fontFamily: 'var(--font-display)' }}
          data-testid="page-header-title"
        >
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm text-muted-foreground mt-1" data-testid="page-header-subtitle">{subtitle}</p>
        )}
      </div>
      <div className="flex items-center gap-2">
        {onRefresh && (
          <Button
            variant="outline"
            size="sm"
            onClick={onRefresh}
            data-testid="page-header-refresh-button"
            className="gap-1.5"
          >
            <RefreshCcw className="h-3.5 w-3.5" />
            Refresh
          </Button>
        )}
        {onExport && (
          <Button
            variant="outline"
            size="sm"
            onClick={onExport}
            data-testid="page-header-export-button"
            className="gap-1.5"
          >
            <Download className="h-3.5 w-3.5" />
            Export
          </Button>
        )}
        {children}
      </div>
    </div>
  );
};

export default PageHeader;
